import { FC, ReactNode, useId } from "react";

import { Flex, Text, ThemeUIStyleObject, getThemeValue } from "@theme/components/ThemeUi";

export interface TagProps {
  children: ReactNode;
  /** Break words on mobile to multi lines, defaults to false
   * Note: if using responsive = true,
   * use `\u00A0` on words you do not want to break to multiple lines
   */
  responsive?: boolean;
  sx?: ThemeUIStyleObject;
  className?: string;
}

export const Tag: FC<TagProps> = ({ children, responsive = false, sx, className }) => {
  return (
    <Flex className={className} sx={{ position: "relative", ml: "s500", ...sx }}>
      <TagIcon />
      <Text
        variant="sansBody01Medium"
        sx={
          {
            color: "white",
            background: (t) => getThemeValue(t, "colors.slateTop"),
            textTransform: "uppercase",
            fontVariantNumeric: "tabular-nums",
            width: responsive ? ["min-content", "max-content"] : "max-content",
            lineHeight: "lh200",
            p: "s200",
            pr: "s300",
          } as ThemeUIStyleObject
        }
      >
        {children}
      </Text>
    </Flex>
  );
};

const TagIcon = () => {
  const id = useId();
  const svgId = `tag-gradient-${id}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 45"
      style={{
        position: "absolute",
        height: "100%",
        right: "calc(100% - 1px)",
      }}
    >
      <linearGradient id={svgId} x1="0%" x2="0%" y1="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: "#3c3c3c", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#1a1a1a", stopOpacity: 1 }} />
      </linearGradient>
      <path
        fill={`url(#${svgId})`}
        fillRule="evenodd"
        d="M0 32.065V13.45L14.071 0h85.965v45.62h-87.4L0 32.065zm9.798-13.35a3.51 3.51 0 1 0-.002 7.018 3.51 3.51 0 0 0 .002-7.018z"
        clipRule="evenodd"
      />
    </svg>
  );
};
